import { Helmet } from "react-helmet-async";
import AboutSection from "@components/AboutSection";
import SectionHeader from "@components/SectionHeader";

function About() {
	return (
		<div>
			<Helmet>
				<title>
					About Steer Smart Driving School | Expert Driving Instructors Canberra
				</title>
				<meta
					name="description"
					content="Learn about Steer Smart Driving School's experienced instructors and proven teaching methods. Dedicated to providing the best driving education in Canberra and ACT."
				/>
				<link rel="canonical" href="https://steersmartdriving.com.au/about" />
			</Helmet>

			<div className="flex flex-col gap-12 py-4 md:py-12">
				<SectionHeader
					title="Who We Are"
					subtitle="We are a team dedicated to providing the best driving education."
					heading="h1"
				/>
				<AboutSection />
			</div>
		</div>
	);
}

export default About;
